import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import CountriesList from "./CountrySelect/CountriesList";
import AreaSelect from "./AreasSelect";
import ActionButton from "../ActionButton";
import ChangeDeliveryTypeDialog from "../CheckoutProcess/SecondStep/ChangeDeliveryTypeDialog";
import {
  fetchBranch,
  fetchStore,
  setBranchDeliveryCharge,
  updateMOV,
} from "../../store/actions";
import { clearCart } from "../../store/actions/cart";
import { modifyAddress } from "../../store/actions/customers";
import ServiceType from "./ServiceType";
import Pickup from "./Pickup";
import Addresses from "../CheckoutProcess/Confirmation/Addresses";
import BranchSelectDrawer from "../BranchSelect/BranchSelectDrawer";
import { fetchDeliveryCharges } from "../../store/actions/store";
import { CircularProgress } from "@material-ui/core";

class index extends Component {
  state = {
    selectedServiceType: this.props.settings.is_menu
      ? 1
      : (this.props.history.location.state?.type + 1 ||
          this.props.address?.selectedDeliveryType + 1) - 1,
    selectedCountryID: this.props.countries[0]?.id,
    branchDeliveryChargeID: null,

    dialogOpen: false,

    selectedPickupBranch: null,

    addressesOpen: false,

    openBranchSelectDrawer: false,

    tempDeliveryCharge: null,
  };
  componentDidUpdate = (prevProps) => {
    if (
      this.props.countries?.length &&
      (this.props.countries.length !== prevProps.countries.length ||
        !this.state.selectedCountryID)
    ) {
      this.setState({ selectedCountryID: this.props.countries[0].id });
    }
  };
  shouldShowSaveButton = () => {
    if (
      !!this.state.branchDeliveryChargeID ||
      !!this.state.selectedPickupBranch
    )
      return true;

    return false;
  };

  shouldGoToAddressPage = () => {
    const { auth, settings } = this.props;
    if (
      this.props.history.location.state?.goBackToAddressPage &&
      this.state.selectedServiceType === 0
    )
      return true;
    let totalCartLength =
      this.props.cart.length + this.props.promo_items.length;
    // if (
    //   settings.enable_social_auth &&
    //   settings.enable_social_auth_staff &&
    //   auth.user &&
    //   totalCartLength > 0
    // ) {
    //   return true;
    // }
    return false;
  };

  getAddressFieldsToReset = (forceReset = false) => {
    const { branchDeliveryChargeID, selectedServiceType } = this.state;
    const { branch, address, settings } = this.props;

    let fields = [
      "block",
      "street",
      "building",
      "avenue",
      "floor",
      "paci",
      "additional",
      "apartment",
      "home_picture",
      "lat",
      "lng",
    ];
    let fieldDict = {};
    const isDeliveryAndSameBDC =
      selectedServiceType === 0 &&
      ((settings.is_branch_based_ordering &&
        branchDeliveryChargeID === branch.bdc) ||
        (!settings.branch_based_ordering &&
          branchDeliveryChargeID === address?.area));
    fields.forEach((field) => {
      if (isDeliveryAndSameBDC && !forceReset)
        fieldDict[field] = !!address ? address[field] || "" : "";
      else fieldDict[field] = "";
    });

    return fieldDict;
  };
  clearCartAndChangeBranch = (forceCurrency = null) => {
    const { branch_delivery_charges, branch, address, cart, promo_items } =
      this.props;
    const {
      branchDeliveryChargeID,
      selectedServiceType,
      selectedPickupBranch,
    } = this.state;
    this.props.branch.loading = true;
    const bdcObj = branch_delivery_charges.find(
      (bdc) => bdc.id === branchDeliveryChargeID
    );
    this.props.fetchBranch(
      selectedServiceType === 0 ? "delivery" : "pickup",
      selectedServiceType === 0
        ? branchDeliveryChargeID
        : bdcObj?.branch || selectedPickupBranch,
      this.props.cart,
      this.props.applied_promo,
      this.props.history,
      forceCurrency,
      null,
      bdcObj?.branch || selectedPickupBranch
    );
    this.props.setBranchDeliveryCharge({
      bdc: branchDeliveryChargeID,
      branch: bdcObj?.branch || selectedPickupBranch,
      isPickup: selectedServiceType == 0 ? false : true,
    });
    this.props.modifyAddress({
      gpsConfirmed:
        selectedServiceType === 0 && branchDeliveryChargeID === branch.bdc
          ? address?.gpsConfirmed || false
          : false,
      selectedDeliveryType: selectedServiceType,
      pickupArea: selectedServiceType === 0 ? null : selectedPickupBranch,
      area: selectedServiceType === 0 ? bdcObj.area_id : null,
      country: selectedServiceType === 0 ? bdcObj.country_id : null,
      selectedAddressType: 0,
      ...this.getAddressFieldsToReset(),
    });

    //Change this function
    //this.props.clearCart();
    if (
      this.props.history.location?.state?.pickupOnly ||
      this.props.history.location?.state?.deliveryOnly
    )
      this.props.history.goBack();
    else if (!this.props.should_force_area_select) {
      let totalCartLength = cart.length + promo_items.length;
      this.props.history.replace(
        this.shouldGoToAddressPage()
          ? "/checkout/address"
          : totalCartLength > 0
          ? "/cart"
          : "/checkout/confirmation"
      );
    } else this.props.history.replace("/");
  };

  setServiceType = (val) => {
    this.setState({ selectedServiceType: val });
    if (val === 0) this.setState({ selectedPickupBranch: null });
    else {
      let pickupBranches = this.props.branches.filter(
        (b) => b.enable_pickup == true
      );
      if (pickupBranches.length === 1) {
        const id = pickupBranches[0].id;
        this.setState({ selectedPickupBranch: id });
      }
      this.setState({
        selectedCountryID: this.props.countries[0]?.id,
        branchDeliveryChargeID: null,
      });
    }
  };

  askForCarInfo = (branch) => {
    const { settings } = this.props;
    if (
      ((!settings.is_branch_based_ordering && settings.ask_for_car_info) ||
        (settings.is_branch_based_ordering &&
          this.props.branches.find((b) => b.id === branch)
            ?.ask_for_car_info)) &&
      branch
    ) {
      return true;
    }
    return false;
  };
  componentDidMount = async () => {
    if (!this.props.fetchedDeliveryCharges) {
      await this.props.fetchDeliveryCharges(this.props.country_code);
    }
    window.scrollTo(0, 0);
    if (
      !(
        this.props.settings.enable_delivery ||
        this.props.settings.enable_delivery_select
      ) ||
      this.props.history.location?.state?.type === 1 ||
      this.props.history.location?.state?.pickupOnly ||
      this.props.cartHasPickupOnly
    ) {
      if (!this.props.history.location?.state?.deliveryOnly) {
        this.setState({ selectedServiceType: 1 });
      }
    }
    if (
      this.props.history.location.state &&
      this.props.history.location.state.prevPath &&
      this.props.history.location.state.prevPath.includes("checkout") &&
      this.props.address &&
      this.props.settings.is_branch_based_ordering
    ) {
      this.setState({
        selectedServiceType: this.props.address?.selectedDeliveryType,
      });
    }

    if (
      !this.state.selectedServiceType &&
      this.state.selectedServiceType !== 0 &&
      !(
        this.props.history.location?.state?.pickupOnly ||
        this.props.history.location?.state?.deliveryOnly
      )
    ) {
      this.setDefaultServiceType();
    }
    if (
      this.props.history.location.state?.newAddress ||
      this.props.cartHasDeliveryOnly ||
      this.props.history.location?.state?.deliveryOnly
    ) {
      if (!this.props.history.location?.state?.pickupOnly) {
        this.setState({ selectedServiceType: 0 });
      }
    }
    if (this.state.selectedServiceType === 1) {
      let pickupBranches = this.props.branches.filter(
        (b) => b.enable_pickup == true
      );
      if (pickupBranches.length === 1) {
        const id = pickupBranches[0].id;
        this.setState({ selectedPickupBranch: id });
      } else if (pickupBranches.length === 0) {
        this.setState({ selectedServiceType: 0 });
      }
    }

    if (
      this.props.address?.country &&
      !!this.props.countries?.find((c) => c.id === this.props.address?.country)
    )
      this.setState({ selectedCountryID: this.props.address?.country });
  };
  setDefaultServiceType = () => {
    if (
      this.props.settings.enable_delivery ||
      this.props.settings.enable_delivery_select
    ) {
      this.setState({ selectedServiceType: 0 });
    } else if (
      this.props.settings.enable_pickup ||
      this.props.settings.enable_pickup_select
    ) {
      this.setState({ selectedServiceType: 1 });
    }
  };

  resetShouldForceAreaSelect = () => {
    if (this.props.should_force_area_select) {
      this.props.resetShouldForceAreaSelect();
    }
  };

  render() {
    const {
      branch,
      language,
      settings,
      branch_delivery_charges,
      cart,
      promo_items,
      countries,
      address,
    } = this.props;
    const {
      selectedCountryID,
      branchDeliveryChargeID,
      selectedServiceType,
      selectedPickupBranch,
    } = this.state;
    let totalCartLength = cart.length + promo_items.length;

    if (!this.props.fetchedDeliveryCharges)
      return (
        <div
          style={{
            minHeight: "100vh",
            backgroundColor: "#F5F5F5",
          }}
        >
          <ProductHeader
            hideBackButton={
              (!branch.branch && settings.force_select_branch) ||
              this.props.should_force_area_select
            }
          />
          <div style={{ marginTop: 86 }}></div>
          <CircularProgress
            color="primary"
            style={{
              alignSelf: "center",
              justifySelf: "center",
              width: 30,
              height: 30,
            }}
          />
        </div>
      );
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#F5F5F5",
        }}
      >
        {this.state.addressesOpen &&
          this.props.auth.user &&
          this.props.auth.addresses?.length &&
          this.state.selectedServiceType === 0 && (
            <Addresses
              open={this.state.addressesOpen}
              onClose={() => {
                this.setState({
                  addressesOpen: false,
                  branchDeliveryChargeID: null,
                });
              }}
              extraAction={() =>
                this.props.history.push("/checkout/confirmation")
              }
              comingFrom="branchSelect"
              onAddNewAddress={() => {
                if (settings.is_branch_based_ordering) {
                  const bdcObj = branch_delivery_charges.find(
                    (bdc) => bdc.id === branchDeliveryChargeID
                  );

                  const branchID = bdcObj?.branch;
                  if (!branchID) return;

                  this.props.setBranchDeliveryCharge({
                    bdc: branchDeliveryChargeID,
                    branch: branchID,
                    isPickup: false,
                  });

                  this.props.updateMOV(bdcObj.minimum_order_value);

                  this.props.modifyAddress({
                    gpsConfirmed:
                      bdcObj.id === branch.bdc
                        ? address?.gpsConfirmed || false
                        : false,
                    selectedDeliveryType: 0,
                    pickupArea: null,
                    area: bdcObj.area_id,
                    country: bdcObj.country_id,
                    selectedAddressType:
                      bdcObj.id === branch.bdc
                        ? address?.selectedAddressType || 0
                        : 0,
                    ...this.getAddressFieldsToReset(true),
                    gpsConfirmed: false,
                  });

                  this.props.history.push("/checkout/address");

                  if (branchID !== branch.branch)
                    window.setTimeout(() => window.location.reload(), 200);
                } else {
                  this.props.modifyAddress({
                    selectedDeliveryType: 0,
                    area: branchDeliveryChargeID,
                    country: this.props.areas.find(
                      (a) => a.id === branchDeliveryChargeID
                    )?.country,
                    gpsConfirmed:
                      branchDeliveryChargeID === address?.area
                        ? address?.gpsConfirmed || false
                        : false,
                    ...this.getAddressFieldsToReset(true),
                    pickupArea: null,
                    selectedAddressType: 0,
                    gpsConfirmed: false,
                  });
                  this.props.history.push("/checkout/address");
                }
              }}
              bdcID={branchDeliveryChargeID}
            />
          )}

        {this.state.openBranchSelectDrawer && (
          <BranchSelectDrawer
            deliveryCharge={this.state.tempDeliveryCharge}
            onClose={() =>
              this.setState({
                tempDeliveryCharge: null,
                openBranchSelectDrawer: false,
              })
            }
            handleContinue={(bdcID) => {
              this.setState({ branchDeliveryChargeID: bdcID });
              this.setState({
                tempDeliveryCharge: null,
                openBranchSelectDrawer: false,
              });
            }}
          />
        )}

        <ChangeDeliveryTypeDialog
          yes={() => this.clearCartAndChangeBranch()}
          dialogOpen={this.state.dialogOpen}
          onClose={() => {
            this.setState({ dialogOpen: false });
          }}
        />
        <ProductHeader
          hideBackButton={
            (!branch.branch && settings.force_select_branch) ||
            this.props.should_force_area_select
          }
        />
        <div style={{ marginTop: 86 }}></div>
        {!settings.is_menu && (
          <ServiceType
            setServiceType={this.setServiceType}
            selectedServiceType={selectedServiceType}
            pickupOnly={
              this.props.history.location?.state?.pickupOnly ||
              this.props.cartHasPickupOnly
            }
            deliveryOnly={
              this.props.history.location?.state?.deliveryOnly ||
              this.props.cartHasDeliveryOnly
            }
          />
        )}
        {selectedServiceType === 0 ? (
          <>
            {countries.length > 1 && (
              <CountriesList
                setSelectedCountry={(id) =>
                  this.setState({
                    selectedCountryID: id,
                    branchDeliveryChargeID: null,
                  })
                }
                selectedCountryID={selectedCountryID}
              />
            )}
            <AreaSelect
              selectedCountryID={selectedCountryID}
              branchDeliveryChargeID={branchDeliveryChargeID}
              setBranchDeliveryChargeID={(id) =>
                this.setState({ branchDeliveryChargeID: id })
              }
              setAddressesOpen={() => this.setState({ addressesOpen: true })}
              OpenBranchSelectDrawer={(dcID) =>
                this.setState({
                  openBranchSelectDrawer: true,
                  tempDeliveryCharge: dcID,
                })
              }
            />
          </>
        ) : (
          <>
            <Pickup
              selectedPickupBranch={this.state.selectedPickupBranch}
              setSelectedPickupBranch={(val) => {
                this.setState({ selectedPickupBranch: val });
              }}
            />
            <div className="free-space-58"></div>
          </>
        )}

        {this.shouldShowSaveButton() && (
          <ActionButton
            action={language == "english" ? "Done" : "حفظ"}
            allowWithMenu
            onClick={() => {
              if (!settings.is_branch_based_ordering) {
                if (selectedServiceType === 0) {
                  const tempCountryID = this.props.areas.find(
                    (a) => a.id === branchDeliveryChargeID
                  )?.country;
                  this.props.modifyAddress({
                    selectedDeliveryType: 0,
                    area: branchDeliveryChargeID,
                    country: tempCountryID,
                    gpsConfirmed:
                      branchDeliveryChargeID === address?.area
                        ? address?.gpsConfirmed || false
                        : false,
                    ...this.getAddressFieldsToReset(),
                    pickupArea: null,
                    selectedAddressType:
                      branchDeliveryChargeID === address?.area
                        ? address?.selectedAddressType || 0
                        : 0,
                  });
                  this.props.updateMOV(
                    this.props.areas.find(
                      (a) => a.id === branchDeliveryChargeID
                    )?.minimun_order_value
                  );
                  if (tempCountryID) {
                    const tempCountryObj = this.props.countries.find(
                      (c) => c.id === tempCountryID
                    );
                    if (
                      tempCountryObj?.dial_code !==
                        this.props.currency.selected &&
                      settings.enable_currency_converter
                    ) {
                      this.props.fetchStore(
                        this.props.cart,
                        this.props.applied_promo,
                        this.props.history,
                        tempCountryObj?.dial_code
                      );
                      this.props.history.replace("/");
                      return;
                    }
                  }
                } else {
                  this.props.modifyAddress({
                    selectedDeliveryType: 1,
                    pickupArea: selectedPickupBranch,
                    gpsConfirmed:
                      branchDeliveryChargeID === address?.area
                        ? address?.gpsConfirmed || false
                        : false,
                    ...this.getAddressFieldsToReset(),
                    area: null,
                    country: null,
                    selectedAddressType: undefined,
                  });

                  if (settings.enable_currency_converter) {
                    const tempPickupBranchObj = this.props.branches.find(
                      (b) => b.id === selectedPickupBranch
                    );
                    if (
                      tempPickupBranchObj?.country_code !==
                      this.props.currency.selected
                    ) {
                      this.props.fetchStore(
                        this.props.cart,
                        this.props.applied_promo,
                        this.props.history,
                        tempPickupBranchObj.country_code
                      );
                      this.props.history.replace("/");
                      return;
                    }
                  }
                }
                if (
                  this.props.history.location?.state?.pickupOnly ||
                  this.props.history.location?.state?.deliveryOnly
                ) {
                  this.props.history.goBack();
                } else
                  this.props.history.replace(
                    totalCartLength > 0 ? "/cart" : "/checkout/confirmation"
                  );
              } else {
                const bdcObj = branch_delivery_charges.find(
                  (bdc) => bdc.id === branchDeliveryChargeID
                );

                const branchID = bdcObj?.branch || selectedPickupBranch;
                const isDelivery = selectedServiceType === 0; // change later
                let new_country_code = null;
                if (isDelivery && bdcObj) {
                  new_country_code = this.props.countries.find(
                    (c) => c.id === bdcObj.country_id
                  )?.dial_code;
                } else {
                  new_country_code = this.props.branches.find(
                    (b) => b.id === branchID
                  )?.country_code;
                }
                if (!!branchDeliveryChargeID || !!selectedPickupBranch) {
                  if (
                    branchID === branch.branch &&
                    !settings.hide_irrelevant_products &&
                    branch.branch != null &&
                    (!settings.enable_currency_converter ||
                      new_country_code === this.props.currency.selected)
                  ) {
                    this.props.setBranchDeliveryCharge({
                      bdc: isDelivery ? branchDeliveryChargeID : null,
                      branch: branchID,
                      isPickup: !isDelivery,
                    });
                    if (isDelivery)
                      this.props.updateMOV(bdcObj.minimum_order_value);
                    else {
                      this.props.updateMOV(0);
                    }
                    this.props.modifyAddress({
                      gpsConfirmed:
                        isDelivery && bdcObj.id === branch.bdc
                          ? address?.gpsConfirmed || false
                          : false,
                      selectedDeliveryType: isDelivery ? 0 : 1,
                      pickupArea: isDelivery ? null : selectedPickupBranch,
                      area: isDelivery ? bdcObj.area_id : null,
                      country: isDelivery ? bdcObj.country_id : null,
                      selectedAddressType:
                        isDelivery && bdcObj.id === branch.bdc
                          ? address?.selectedAddressType || 0
                          : !isDelivery
                          ? undefined
                          : 0,
                      ...this.getAddressFieldsToReset(),
                    });
                    if (
                      this.props.history.location?.state?.pickupOnly ||
                      this.props.history.location?.state?.deliveryOnly
                    ) {
                      this.resetShouldForceAreaSelect();
                      this.props.history.goBack();
                    } else {
                      if (this.props.should_force_area_select) {
                        this.resetShouldForceAreaSelect();
                        this.props.history.replace("/");
                      } else {
                        this.props.history.replace(
                          this.shouldGoToAddressPage()
                            ? "/checkout/address"
                            : totalCartLength > 0
                            ? "/cart"
                            : "/checkout/confirmation"
                        );
                      }
                    }
                  } else if (
                    settings.enable_currency_converter &&
                    new_country_code !== this.props.currency.selected
                  ) {
                    this.clearCartAndChangeBranch(new_country_code);
                  } else if (branch.branch == null) {
                    this.clearCartAndChangeBranch();
                  } else if (
                    (branchID != branch.branch ||
                      settings.hide_irrelevant_products) &&
                    branch.branch != null &&
                    totalCartLength > 0
                  ) {
                    this.setState({ dialogOpen: true });
                  } else {
                    this.clearCartAndChangeBranch();
                  }
                } else {
                }
              }
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    branches: state.store.store.branches,
    themeColor: state.store.store.settings.dark,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    branch: state.branch,
    address: state.customers.address,
    areas: state.store.store.areas,
    cart: state.cart.cart,
    applied_promo: state.cart.promos,
    settings: state.store.store.settings,
    countries: state.store.store.all_countries || state.store.store.countries,
    thirdLoading: state.store.thirdLoading,
    promo_items: state.cart.promo_items,
    auth: state.auth,
    cartHasPickupOnly: state.cart.pickup_only_items > 0,
    cartHasDeliveryOnly: state.cart.delivery_only_items > 0,
    should_force_area_select: state.store.store.should_force_area_select,
    currency: state.currency,
    country_code: state.store.store.country_code,
    fetchedDeliveryCharges: state.store.fetchedDeliveryCharges,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStore: (cart, promo, history, forceCurrency) =>
      dispatch(fetchStore(cart, promo, history, forceCurrency)),
    fetchBranch: (
      type,
      bdc_id,
      cart,
      promo,
      history,
      forceCurrency,
      QRValid,
      branchID
    ) =>
      dispatch(
        fetchBranch(
          type,
          bdc_id,
          cart,
          promo,
          history,
          forceCurrency,
          QRValid,
          branchID
        )
      ),
    setBranchDeliveryCharge: (bdc_obj) =>
      dispatch(setBranchDeliveryCharge(bdc_obj)),
    clearCart: () => dispatch(clearCart()),
    modifyAddress: (obj) => dispatch(modifyAddress(obj)),
    updateMOV: (mov) => dispatch(updateMOV(mov)),
    clearAddress: () => dispatch({ type: "CLEAR_ADDRESS" }),
    resetShouldForceAreaSelect: () =>
      dispatch({ type: "RESET_SHOULD_FORCE_AREA_SELECT" }),
    clearStore: () => dispatch({ type: "CLEAR_STORE" }),
    fetchDeliveryCharges: (countryCode) =>
      dispatch(fetchDeliveryCharges(countryCode)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
